<template>
  <div style="margin-top: 6px;">
    <h3>
      Mon adresse
      <b-button disabled v-b-tooltip.hover title="Modifier mon adresse">
        <font-awesome-icon icon="pen" size="xs" />
      </b-button>
    </h3>
    <p class="explication">
      Veuillez nous informer de tout changement d'adresse.
    </p>

    <table class="table" v-if="userInfos.address">
      <tbody>
      <tr>
        <th>Rue</th>
        <td>{{userInfos.address.street}}</td>
      </tr>
      <tr v-if="userInfos.address.app">
        <th>Appartement</th>
        <td>{{userInfos.address.app}}</td>
      </tr>
      <tr>
        <th>Ville</th>
        <td>{{userInfos.address.city}}</td>
      </tr>
      <tr>
        <th>Province</th>
        <td>{{userInfos.address.province}}</td>
      </tr>
      <tr>
        <th>Code postal</th>
        <td>{{userInfos.address.postal_code}}</td>
      </tr>
      <tr>
        <th>Pays</th>
        <td>{{userInfos.address.country}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import MemberEditAddressModal from './Membre_ModifierAdresse';

  export default {
    name: 'member-address',
    computed: {
      ...mapState({
        userInfos: state => state.account.user.infos
      })
    },
    methods: {
      editAddress() {
        this.$modal.show(
          MemberEditAddressModal, {},
          {
            height: 'auto',
            minHeight: 300,
            name: 'add-edit-address-modal',
            root: this.$root
          }
        );
      }
    }
  };
</script>

<style lang="scss" scoped>
  .explication {
    margin-bottom: 10px;
    margin-top: 10px;
    text-align: center;
    color: dimgray;
  }
</style>
